import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Fir163jsyncService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following sync163jTriggerService.js pattern exactly
  triggerSync(
    baseUrl: string,
    returnClobSettingsObj: any,
    ecSaveDtls: any[],
    syncSaveDtls: any[],
    modalName: string,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action codes like AngularJS service
    const rerunUrl = `${baseUrl}/saveJsonObject?action_code=vr35gl`;
    const amtSyncUrl = `${baseUrl}/saveJsonObject?action_code=r7zv3b`;
    const url = (modalName === 'trigger163jamtsync') ? amtSyncUrl : rerunUrl;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    // Build clob_settings from returnClobSettingsObj
    const clobSettings: any = {
      sso_id: returnClobSettingsObj?.sso_id || globalService?.sso_id || filterParams?.sso_id || '',
      combination_key: returnClobSettingsObj?.combination_key || ''
    };
    
    // Build JSON objects exactly like AngularJS service
    const jsonObj = JSON.stringify(ecSaveDtls || []);
    const jsonSettings = JSON.stringify(clobSettings);
    
    // Extend with clob_data and clob_settings
    params = _.extend({ clob_data: jsonObj }, params);
    params = _.extend({ clob_settings: jsonSettings }, params);
    
    // Core parameters with fallbacks
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || '2024';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || '74';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || '250';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || '';
    params.scenarioCode = filterParams?.scenarioCode || globalService?.scenarioCode || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';

    // 🚀 CRITICAL: Build checkLockedbj array from syncSaveDtls (multiple entities)
    const checkLockedbj: any[] = [];
    if (syncSaveDtls && syncSaveDtls.length > 0) {
      syncSaveDtls.forEach((item: any) => {
        checkLockedbj.push({
          "leid": item.leid || '',
          "me_code": item.me_code || 'HOELIM',
          "cdr_number": item.cdr_number || item.leid || '',
          "reporting_period": 1,
          "combination_key": parseInt(item.combination_key) || 0,
          "scenario_key": parseInt(filterParams?.scenario || '74')
        });
      });
    }
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Additional required fields
    params.filing_key = filterParams?.filing_key || rowData?.CONSOL_GROUP_KEY || '1';
    params.system = filterParams?.system || globalService?.system || 'A';
    params.filter_by = filterParams?.filter_by || globalService?.filter_by || '9';
    params.parent_me_string = filterParams?.parent_me_string || globalService?.parent_me_string || '';
    params.combination_key = returnClobSettingsObj?.combination_key || '';
    params.sso_id = returnClobSettingsObj?.sso_id || '';
    
    // Set process_name based on modalName
    params.process_name = (modalName === 'trigger163jamtsync') ? 
      "RUN_163J_TB_AMT_SYNC" : 
      "TRIGGER_SYNC_163J_PROCESS";

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      const val = params[key];
      if (val !== undefined && val !== null && typeof val !== 'object') {
        urlEncoded.set(key, String(val));
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // 🚀 CRITICAL: Wrapper method that calls triggerSync - following AngularJS pattern
  sendSyncDetails(
    baseUrl: string,
    returnClobSettingsObj: any,
    ecSaveDtls: any[],
    syncSaveDtls: any[],
    modalName: string,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    
    // Delegate to triggerSync method with all parameters
    return this.triggerSync(
      baseUrl,
      returnClobSettingsObj,
      ecSaveDtls,
      syncSaveDtls,
      modalName,
      globalService,
      filterParams,
      rowData
    );
  }

  // 🚀 CRITICAL: Additional utility method for different action codes
  triggerAmtSync(
    baseUrl: string,
    returnClobSettingsObj: any,
    ecSaveDtls: any[],
    syncSaveDtls: any[],
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    
    // Call triggerSync with amt sync modal name
    return this.triggerSync(
      baseUrl,
      returnClobSettingsObj,
      ecSaveDtls,
      syncSaveDtls,
      'trigger163jamtsync', // This will use the amt_sync URL and process name
      globalService,
      filterParams,
      rowData
    );
  }
}
